/**
 * Card Media Slider - prev/next arrows (desktop) and dots (mobile)
 */
class CardMediaSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.card-media-slider__track');
    this.prevBtn = this.querySelector('.card-media-slider__arrow--prev');
    this.nextBtn = this.querySelector('.card-media-slider__arrow--next');
    this.dots = this.querySelectorAll('.card-media-slider__dot');
    if (!this.track) return;

    this.#bindEvents();
    this.#observeScroll();
    this.#updateState();
  }

  #bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.#prev();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.#next();
      });
    }
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.#scrollToSlide(index);
      });
    });
  }

  #observeScroll() {
    this.track.addEventListener('scroll', () => this.#updateState());
  }

  #prev() {
    const slides = this.track.querySelectorAll('.card-media-slider__slide');
    const slideWidth = this.track.offsetWidth;
    const currentIndex = Math.round(this.track.scrollLeft / slideWidth);
    const prevIndex = Math.max(0, currentIndex - 1);
    this.#scrollToSlide(prevIndex);
  }

  #next() {
    const slides = this.track.querySelectorAll('.card-media-slider__slide');
    const slideWidth = this.track.offsetWidth;
    const currentIndex = Math.round(this.track.scrollLeft / slideWidth);
    const nextIndex = Math.min(slides.length - 1, currentIndex + 1);
    this.#scrollToSlide(nextIndex);
  }

  #scrollToSlide(index) {
    const slides = this.track.querySelectorAll('.card-media-slider__slide');
    const slide = slides[index];
    if (slide) {
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
  }

  #updateState() {
    const slides = this.track.querySelectorAll('.card-media-slider__slide');
    const slideWidth = this.track.offsetWidth;
    const scrollLeft = this.track.scrollLeft;
    const currentIndex = Math.round(scrollLeft / slideWidth);
    const activeIndex = Math.min(currentIndex, slides.length - 1);
    const isFirst = activeIndex <= 0;
    const isLast = activeIndex >= slides.length - 1;

    if (this.prevBtn) {
      this.prevBtn.disabled = isFirst;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = isLast;
    }
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('card-media-slider__dot--active', i === activeIndex);
    });
  }
}

if (!customElements.get('card-media-slider')) {
  customElements.define('card-media-slider', CardMediaSlider);
}
